import React from 'react';
import {FormProvider, useForm} from 'react-hook-form';
import TextFormField from '@common/components/forms/text-form-field';
import PasswordFormField from '@common/components/forms/password-form-field';
import AppButton from "@common/components/app-button";
import useAuth from "../hooks/use-auth";
import {useNavigate} from "react-router-dom";

interface LoginFormData {
    email: string;
    password: string;
}

const LoginForm: React.FC = () => {
    const navigate = useNavigate();
    const {login} = useAuth();

    const methods = useForm<LoginFormData>({
        defaultValues: {
            email: '',
            password: '',
        },
    });
  const values = methods.watch();

    const {handleSubmit, formState: {isSubmitting}} = methods;

    const handleLogin = async () => {
        await methods.trigger();

        if (!methods.formState.isValid) {
            return;
        }

        const body = methods.getValues();
        try {
            await login(body.email, body.password);
        } catch (error) {
            console.error("Login failed:", error);
        }
    };

    return (
        <FormProvider {...methods}>
            <form onSubmit={handleSubmit(handleLogin)} className="space-y-6">
                <TextFormField
                    name="email"
                    label="Email"
                    placeholder="Email"
                />

                <PasswordFormField
                    name="password"
                    label="Hasło"
                    placeholder="Hasło"
                    showPasswordToggle={false}
                />

                {methods.formState.errors.root && (
                    <div className="text-red-600 text-sm text-center">
                        {methods.formState.errors.root.message}
                    </div>
                )}

                <div className="flex items-center justify-between">
                    <a onClick={()=> navigate("/forgot-password")} className="cursor-pointer text-xs font-semibold text-primary hover:text-teal-600 transition-colors">
                        Nie pamiętasz hasła?
                    </a>

                    <AppButton
                        type='submit'
                        disabled={!values.email || !values.password}
              loading={isSubmitting}
              label={'Zaloguj'}
              className='!rounded-[4rem] text-on-primary text-[1rem] h-[40px] font-semibold bg-primary hover:bg-primary/80'/>
        </div>
      </form>
    </FormProvider>
  );
};

export default LoginForm;
